// CustomerDetailPage - Wrapper component for customer detail view
// Created as part of ENG2-1701: Update Routing and Page Integration

import React from 'react'
import { Box } from '@mui/material'
import { useParams } from 'react-router-dom'
import { Topbar } from 'layouts'
import { Stack } from 'components'
import SelectedCustomer from './selected-customer'
import ExportUsers from 'components/export-users'
import { useCustomerData } from 'services/queries/use-customer-data'
import { useUsers } from 'services/queries/use-users'
import { BreadcrumbItem } from 'layouts/topbar/topbar.types'

const CustomerDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const selectedCustomer = id || null

  const { data: customerData, isLoading: customerLoading } =
    useCustomerData(selectedCustomer)
  const { data: usersData, isLoading: usersLoading } = useUsers(selectedCustomer)

  const breadcrumbs: BreadcrumbItem[] = [
    { label: 'Customers', path: '/' },
    ...(customerData?.name ? [{ label: customerData.name }] : []),
  ]

  return (
    <>
      <Topbar
        breadcrumbs={breadcrumbs}
        actions={
          !usersLoading && !customerLoading && !!usersData ? (
            <Stack spacing={1}>
              <ExportUsers customerData={customerData} usersData={usersData} />
            </Stack>
          ) : null
        }
      />
      <Box sx={{ p: 3 }}>
        {selectedCustomer && <SelectedCustomer selectedCustomer={selectedCustomer} />}
      </Box>
    </>
  )
}

export { CustomerDetailPage }
export default CustomerDetailPage
